export const adminRoles = [
  'ROLE_QIMA_ADMIN',
  'ROLE_MINERVA_ADMIN',
  'ROLE_ACELEN_ADMIN',
  'ROLE_IRANCHO_ADMIN',
  'ROLE_WALMART_ADMIN',
  'ROLE_THOMAS_FOODS_ADMIN',
  'ROLE_INTERSTATE_MEAT_DISTRIBUTORS_ADMIN',
  'ROLE_ASSAI_ADMIN',
  'ROLE_SAFETRACE_ADMIN',
  'ROLE_SAFE_SUPORTE',
  'ROLE_GRAOSDOPARA_ADMIN'
];

export const clientRoles = [
  'ROLE_QIMA_REQUESTER',
  'ROLE_MINERVA_REQUESTER',
  'ROLE_ACELEN_REQUESTER',
  'ROLE_IRANCHO_REQUESTER',
  'ROLE_WALMART_REQUESTER',
  'ROLE_THOMAS_FOODS_REQUESTER',
  'ROLE_INTERSTATE_MEAT_DISTRIBUTORS_REQUESTER',
  'ROLE_ASSAI_REQUESTER',
  'ROLE_SAFETRACE_REQUESTER',
  'ROLE_GRAOSDOPARA_REQUESTER'
];